<template>
<div class="access">
  <div class="access__container">
    <h1 class="access__title">CAMBIAR CONTRASEÑA</h1>
    <p class="access__text">Proporciona los datos solicitados, el código de recuperación fue enviado a tu correo electrónico en el paso anterior</p>
    <form class="form" @submit.prevent="reset">
      <div class="form__fieldset">
        <div class="form__container form__container--wide">
          <label for="email" class="form__label">Email</label>
          <input type="text" class="form__input" name="email" id="email" v-model="element.email" v-validate="validation.email">
          <span v-show="errors.has('email')" class="form__alert">{{ errors.first('email') }}</span>
        </div>
        <div class="form__container form__container--wide">
          <label for="code" class="form__label">Código de Recuperación</label>
          <input type="text" class="form__input" name="code" id="code" v-model="element.code" v-validate="validation.code">
          <span v-show="errors.has('code')" class="form__alert">{{ errors.first('code') }}</span>
        </div>
        <div class="form__container form__container--wide">
          <label for="password" class="form__label">Contraseña</label>
          <input type="password" ref="password" class="form__input" name="password" id="password" v-model="element.password" v-validate="validation.password">
          <span v-show="errors.has('password')" class="form__alert">{{ errors.first('password') }}</span>
        </div>
        <div class="form__container form__container--wide">
          <label for="confirm_password" class="form__label">Confirmar Contraseña</label>
          <input type="password" class="form__input" name="confirm_password" id="confirm_password" v-model="element.confirm_password" v-validate="validation.confirm_password">
          <span v-show="errors.has('confirm_password')" class="form__alert">{{ errors.first('confirm_password') }}</span>
        </div>
        <input type="submit" class="btn btn__default btn--regular" value="Cambiar">
        <router-link class="btn btn__transparent btn--regular" :to="{name: 'login'}">Iniciar Sesión</router-link>
      </div>
    </form>
  </div>
</div>
</template>

<script>
import httpService from '@/api/request'
import {auth} from '@/assets/js/libs/sessions'
export default {
  mixins: [httpService],
  data: function () {
    return {
      element: {
        email: null,
        password: null,
        confirm_password: null,
        code: null
      },
      validation: {
        email: 'required|email',
        code: 'required|numeric|min:6|max:6',
        password: 'required|min:6',
        confirm_password: 'required|min:6|confirmed:password'
      }
    }
  },
  methods: {
    reset: function () {
      this.$validator.validateAll()
        .then(
          response => {
            if (response) {
              let httpRequest = {
                module: 'reset',
                element: this.element,
                params: ''
              }
              this.post(httpRequest)
                .then(
                  reset => {
                    auth.setSession(reset)
                    this.$store.commit('login')
                    this.$store.commit('notificate', {
                      title: 'LOGIN CORRECTO',
                      text: 'Ha iniciado sesión de forma correcta.',
                      type: 'success'
                    })
                  }
                )
                .catch(
                  () => {
                    this.$store.commit('logout')
                    this.$store.commit('notificate', {
                      title: 'LOGIN INCORRECTO',
                      text: 'Ha ocurrido un error al intentar iniciar sesión, por favor, intente de nuevo.',
                      type: 'error'
                    })
                  }
                )
            } else {
              this.$store.commit('notificate', {
                title: 'CAMPOS REQUERIDOS',
                text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
                type: 'warn'
              })
            }
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/_access"
@import "../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/access/reset.vue